import "./App.scss"
import Approuter from "./router/router";
function App() {
  return (
    <div className="App">
      <Approuter/>
    </div>
  );
}

export default App;
